import { Component } from 'react';

export class CloseSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                className={className}
            >
                <path
                    d="M1.5 1.5l16.568 16.568m-16.556.42L18.478 1.522"
                    fill="none"
                    fillRule="evenodd"
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    opacity=".899"
                />
            </svg>
        );
    }
}
